var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOfflineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50008 0.666992C3.90008 0.666992 0.166748 4.40033 0.166748 9.00033C0.166748 13.6003 3.90008 17.3337 8.50008 17.3337C13.1001 17.3337 16.8334 13.6003 16.8334 9.00033C16.8334 4.40033 13.1001 0.666992 8.50008 0.666992ZM9.33342 13.167H7.66675V8.16699H9.33342V13.167ZM9.33342 6.50033H7.66675V4.83366H9.33342V6.50033Z",
    fill: "#EB6200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOfflineIcon);
export default __webpack_public_path__ + "static/media/info-offline-icon.ac73e0f4fb59a30a150a7374aa1018af.svg";
export { ForwardRef as ReactComponent };